module.exports = __webpack_public_path__ + "img/Kaehler2019.1b4152bb.jpg";